import { render, staticRenderFns } from "./ExpertReports.vue?vue&type=template&id=53119c72&scoped=true"
import script from "./ExpertReports.vue?vue&type=script&lang=ts"
export * from "./ExpertReports.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53119c72",
  null
  
)

export default component.exports